export const ISO_ANGLE = 30;
export const ISO_ROTATION = Math.PI / 4;
